import { Loader } from "@mantine/core";
import { ComponentProps } from "react";
import { FieldValues } from "react-hook-form";

import { useSearchTrucks, UseSearchTrucksParams } from "@/features/dashboard/pedidos/_hooks/useSearchTrucks";

import { Input } from "../_Input";

type TrucksFieldsProps<TFieldValues extends FieldValues> = Omit<ComponentProps<typeof Input.Select<TFieldValues>>, "data" | "leftSection"> & Omit<UseSearchTrucksParams, "search">;

export function TrucksFields<TFieldValues extends FieldValues>({
  control,
  name,
  onSearchChange,
  searchValue,
  defaultSearchValue,
  getLabel,
  getValue,
  ...props
}: TrucksFieldsProps<TFieldValues>) {
  const {
    data: searchTrucksResults,
    actions: { setSearchTruck },
    state: { searchTruck, isFetching: isFetchingTrucks }
  } = useSearchTrucks({ search: defaultSearchValue, getLabel, getValue });

  const handleSearchChange = (value: string) => {
    setSearchTruck(value);
    onSearchChange?.(value);
  };

  return (
    <Input.Select
      data={searchTrucksResults.options}
      leftSection={isFetchingTrucks && <Loader size="sm" />}
      searchValue={searchValue || searchTruck}
      onSearchChange={handleSearchChange}
      placeholder="Selecione o Caminhão"
      label="Caminhão"
      control={control}
      name={name}
      {...props}
    />
  );
}
